/* eslint-disable camelcase */
import axios from 'axios';

import { refresh } from '../modules/auth/services/auth-api';
import { tokenStorage } from './storage-service';
import HttpEventPublisher from './http-event-publisher';

const errorResponseInterceptor = async (error) => {
  // console.log('authResponseInterceptor error', error);
  HttpEventPublisher.publishResponse();

  if (!error.response) { // network error
    // tokenMutations.setRefreshToken(null);
    // Note: even if we kill token here, we better use clearTokens() + storage
    const err = { status: 418, error };
    return Promise.reject(err);
  }
  const { config, response: { status } } = error;
  const originalRequest = config;
  // handling other error response statuses
  switch (status) {
    case 400:
      console.error('Error Interceptor 400: ', error);
      break;

    case 401: // authentication error
      try {
        // const { refreshToken } = tokenStorage;
        const refreshToken = tokenStorage.getRefreshToken();
        if (!refreshToken) return Promise.reject(error);
        const retVal = await refresh(refreshToken);
        const { access_token, refresh_token } = retVal.data;
        tokenStorage.setAccessToken(access_token);
        tokenStorage.setRefreshToken(refresh_token);
        originalRequest.headers.Authorization = `Bearer ${access_token}`;

        return axios.request(originalRequest);
      } catch (err) {
        // const currentRequest = err.error.config;
        // console.log('errorResponseInterceptor currentRequest', currentRequest);
        // if (currentRequest.method === 'post' && currentRequest.url === '/token') {
        //  tokenMutations.setRefreshToken(null);
        // Note: even if we kill token here, we better use clearTokens() + storage
        // }
      }
      break;

    case 409:
      console.error('Conflict occurred: ', error.message);
      break;

    case 500:
      console.error('Server error: ', error.message);
      break;

    default:
      console.error(error.response.status, error);
      // console.log('Original request: ', originalRequest);
  }
  return Promise.reject(error);
};

const successResponseInterceptor = async (response) => {
  HttpEventPublisher.publishResponse();
  return response;
};

export default { errorResponseInterceptor, successResponseInterceptor };
